import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import '../style/index.css'

const Layout = ({ children }) => (
  <div>
    <Helmet>
      <title>Drivers Benefits</title>
      <meta name="description" content="New and Free Benefits for Black Car Drivers in New York" />
      <meta name="theme-color" content="#3261AB" />
      <meta property="og:title" content="Drivers Benefits" />
      <meta property="og:type" content="website" />
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-121451799-1"></script>
      <script>{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-121451799-1');
      `}</script>
      <script id="mcjs">{`
        !function(c,h,i,m,p){
          m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)
        }(document,"script","https://chimpstatic.com/mcjs-connected/js/users/cc7a6f267b2d6d48d185f12a6/40d12947dea3da5ffa91c4dfd.js");
      `}</script>
    </Helmet>
    {children()}
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js